module.exports = __webpack_public_path__ + "static/img/78.b06149a.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/img_left_icon/78.png
// module id = iAqP
// module chunks = 1